<template>
	<form class="form" @submit.prevent="submit">
		<h2 class="title --uppercase">{{ $beet.options.form[formType].title }}</h2>
		<p class="description">{{ $beet.options.form[formType].description }}</p>
		<div v-if="!form.received && !form.submitted">
			<p v-if="form.server__error" class="form__error --server">{{ form.server__error }}</p>
			<component :is="formFields" v-model="form" @updated="data => form.data = data" />
			<button type="submit" class="button --right" :disabled="!form.valid">
				{{ $beet.options.form[formType].submit }}
			</button>
		</div>
		<div v-if="!form.received && form.submitted" class="form__loading">
			<div class="loader" />
		</div>
		<div v-if="form.received && form.submitted">
			<div class="form__confirmation">
				<Icon id="checkmark" />
			</div>
			<p>{{ $beet.options.form[formType].confirmation }}</p>
		</div>
	</form>
</template>

<script>
import { Icon } from '@/components/global'
import { JobAlertForm } from '@/components/form/blocks'
import { UsesRoutesMixin } from '@/mixins'

export default {
	name: 'FormModal',
	mixins: [UsesRoutesMixin],
	components: { Icon },
	data() {
		return {
			form: {
				fields: false,
				received: false,
				server__error: null,
				submitted: false,
				valid: false
			}
		}
	},
	computed: {
		formFields() {
			switch (this.$route.query[this.QUERY_KEYS.FORM]) {
				case 'job_alert':
					return JobAlertForm
				default:
					return null
			}
		},
		formType() {
			return {
				'job_alert': 'jobAlert'
			}[this.$route.query[this.QUERY_KEYS.FORM]]
		}
	},
	methods: {
		async submit() {
			try {
				this.form.server__error = null
				this.form.submitted = true

				await this.$recaptcha('form_submit')

				await this.$store.dispatch(`send_${this.$route.query[this.QUERY_KEYS.FORM]}`, this.form.fields)

				this.form.received = true
			} catch (error) {
				this.form.submitted = false
				if(error.response) {
					this.form.server_error = error.response.data
				}
				else {
					this.form.server_error = this.$t('error.formSending')
				}
			}
		}
	}
}
</script>